import React, { memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import history from "utils/history";

//components
import NoAbsence from "components/Absences/NoAbsence";
import CustomTableV2 from "components/CustomTableV2";

function TableAbsence({
  dataSource,
  dataColumns,
  emptyTitle,
  emptyContent,
  activeTab,
  createAbsenceAction,
  openFinishedAbsence,
  allSelectedItemUpd,
  getCheckboxProps,
  showSorterTooltip,
  // default props
  className,
  ...rest
}) {
  const mainClassNames = classNames("table-absence-wrapper", className);
  const { t } = useTranslation();

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      allSelectedItemUpd(selectedRows, selected);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      allSelectedItemUpd(selectedRows, selected);
    },
  };

  return (
    <div className={mainClassNames}>
      {dataSource.length > 0 ? (
        <CustomTableV2
          columns={dataColumns}
          dataSource={dataSource}
          pagination={{ pageSize: 50 }}
          rowKey={record => record._id}
          rowSelection={activeTab !== "finished" ? {
            ...rowSelection,
            getCheckboxProps: !!getCheckboxProps && getCheckboxProps || rowSelection?.getCheckboxProps,
          } : null}
          scroll={{ y: "55vh" }}
          showSorterTooltip={showSorterTooltip}
          onRow={(record, index) => {
            return {
              onClick: () => history.push(`/absences/${record?._id}`),
            };
          }}
          locale={{
            emptyText: (
              <NoAbsence
                title={!!emptyTitle ? emptyTitle : t("absences.noAbsencesToProcess")}
                content={!!emptyContent ? emptyContent : t("absences.youProcessedAllAbsences")}
                newAction={createAbsenceAction}
                filterAction={openFinishedAbsence}
              />
            ),
          }}
        />
      ) : (
        <NoAbsence
          title={!!emptyTitle ? emptyTitle : t("absences.noAbsencesToProcess")}
          content={!!emptyContent ? emptyContent : t("absences.youProcessedAllAbsences")}
          newAction={createAbsenceAction}
          filterAction={openFinishedAbsence}
        />
      )}
    </div>
  );
}

TableAbsence.defaultProps = {
};
TableAbsence.propTypes = {
  dataColumns: PropTypes.array,
  dataSource: PropTypes.array,
  activeTab: PropTypes.string,
  emptyTitle: PropTypes.string,
  emptyContent: PropTypes.string,
  createAbsenceAction: PropTypes.func,
  openFinishedAbsence: PropTypes.func,
};

export default memo(TableAbsence);
